// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"aV-z","trustedRetailerTooltipWrapper":"bV-z"};